import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";

import { PDFDialogComponent } from "src/app/signup-organization/pdf-dialog/pdf-dialog.component";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';


@Component({
  selector: 'app-employer-active-plans',
  templateUrl: './employer-active-plans.component.html',
  styleUrls: ['./employer-active-plans.component.scss']
})

export class EmployerActivePlansComponent implements OnInit {
  @Input() activeTab: boolean = false;

  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  employerId: number;
  isActive: boolean;
  // selectedPlan:any={};
  selectedPlans: any[] = [];

  noActivePlan : boolean = false;
  selectedEmployeeIds: number[]=[];
  subscriptionPlans1 = [
    {
      id: 1,
      name: "Health",
      price:'$7.90',
      active: false,

      features: [
        "Teladoc ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx"
      ]
    },
    {
      id: 2,
      name: "Health Plus",
      price:'$19.98',
      active: false,

      features: [
        "Teladoc ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Manifest Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    {
      id: 3,
      name: "Mental Health",
      price:'$10.15',
      active: false,

      features: [
        "Teladoc Mental Health ($0 Visit Fee)",
        "Health Advocate Solutions",
        "NB Fitness",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    {
      id: 4,
      name: "Premium Health",
      price:'$36.35',
      active: false,
      features: [
        "Teladoc ($0 Visit Fee)",
        "Teladoc Mental Health ($0 Visit Fee)",
       " Manifest Rx",
        "Health Advocate Solutions",
        "NB Fitness",
        "LifeLock Essential Individual",
        "NB Pet Telehealth",
        "NB Rx",
        "Lab Testing",
        "NB Deals",
        "NB Travel",
        "NB Pet Rx",
      ]
    },
    // Add more plans as needed
  ];
  subscriptionTypes: any;
  subscriptionTypeIds: any;
  activeSubscriptionId: any;
  activeSubscriptions: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private employerService: EmployerService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private patientService: PatientService,
    private utils: UtilsService,
    
  ) {}
  ngAfterViewInit(): void {
    this.getUserDetails();

  }
  ngOnInit() {
    this.getUserDetails();
    }

  getUserDetails() {
    // this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        // this.getEmployerHealthSubscriptionByEmployerId();
        this.getPatientSubscriptionTypes(()=>{this.getEmployerHealthSubscriptionByEmployerId();})


      },
      (error) => { console.error(error); }
    );
  }
 
// getEmployerHealthSubscriptionByEmployerId() {
//   this.loaderService.show();
//   this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
//     (res) => {
//       if (res && res.resultStatus && res.resultStatus.isSuccess && res.result) {
//         // this.utils.showMessageSnackBar(res.resultStatus.message || "Success", false); // Show success message

//         // Set the active status and subscriptionTypeId from the API response
//         this.selectedType = res.result.subscriptionTypeId;
//         this.activationType = res.result.active ? "Activate" : "Deactivate";  
        
//         // Update the subscription plan's active status
//         this.selectedPlan = res.result;
//         console.log("Selected Plan:", this.selectedPlan);
//         // this.noActivePlan = false; // Ensure the flag is reset if we found a plan
//         this.noActivePlan = !res.result.subscriptionTypeId; // Ensuring this correctly reflects the plan availability

//       } else {
//         console.warn("No active subscription found.");
//         this.noActivePlan = true;
  
//                    // If isSuccess is false, show the error message
//                    const errorMessage = res.resultStatus.errorMessages
//                    ? res.resultStatus.errorMessages.join(", ")
//                    : "Failed to fetch subscription details.";
                 
//                  this.utils.showMessageSnackBar(errorMessage, true);
//       }

//       this.loaderService.hide();
//     },
//     (error) => {
//       console.error("Error fetching subscription details:", error);
//       this.noActivePlan = true;
//       this.loaderService.hide();
//       // Show a generic error message
//       this.utils.showMessageSnackBar("An error occurred while fetching employer health subscription.", true);

//     }
//   );
// }

  //   ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['activeTab'] && changes['activeTab']) {
  //     this.handleTabActivation();
  //   }
  // }
 

  getEmployerHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && Array.isArray(res.result)) {
          // Filter all active subscriptions
          this.activeSubscriptions = res.result.filter(sub => sub.active);
  
          if (this.activeSubscriptions.length > 0) {
            this.selectedPlans = this.activeSubscriptions;
            this.noActivePlan = false;
  
            console.log("Selected Plans:", this.selectedPlans);
//             this.subscriptionTypeIds = activeSubscriptions.map(sub => sub.subscriptionTypeId);
// console.log("Subscription Type IDs:", this.subscriptionTypeIds);
// this.activeSubscriptions.forEach((sub, index) => {
//   this.activeSubscriptionId = sub.subscriptionTypeId
//   console.log(`Subscription ${index + 1} Type ID:`, this.activeSubscriptionId);
// });

this.subscriptionTypeIds = this.activeSubscriptions.map(sub => sub.subscriptionTypeId);
console.log("All active subscriptionTypeIds:", this.subscriptionTypeIds);

            console.log("subTYpeid:",this.selectedPlans)
          } else {
            console.warn("No active subscription found.");
            this.selectedPlans = [];
            this.noActivePlan = true;
          }
        } else {
          console.warn("No subscription data returned.");
          this.selectedPlans = [];
          this.noActivePlan = true;
  
          const errorMessage = res.resultStatus && res.resultStatus.errorMessages
            ? res.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
  
          this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.selectedPlans = [];
        this.noActivePlan = true;
        this.loaderService.hide();
  
        this.utils.showMessageSnackBar("An error occurred while fetching employer health subscription.", true);
      }
    );
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'] && this.activeTab === true) {
      this.getUserDetails();
    }
  }
  handleTabActivation(): void {
    console.log('My Subscriptions tab is active');
    // Your additional logic here
    this.getUserDetails();
  }



  upgradeSubscription() {
    // Close the modal programmatically
    // document.getElementById("clsUpgradeModal").click();
 // Switch to the "Subscriptions" tab
 const medicalHistoryTab = document.getElementById('medicalHistory-tab');

 if (medicalHistoryTab) {
   // Use jQuery to trigger the tab switch
   if (window['$']) {
     const $ = window['$'];
     $(medicalHistoryTab).tab('show'); // Bootstrap tab API with jQuery
   } else {
     console.error('jQuery is not available.');
   }
 } else {
   console.error('Medical History tab not found.');
 }
  }
  setActiveSubscriptionId(id: number): void {
    this.activeSubscriptionId = id;
    console.log('Selected subscriptionTypeId:', id);
  }
  cancelSubscription() {
    this.loaderService.show();

    this.activationType = "Deactivate";
    // this.isActive = false;  // Set active to false explicitly for cancelation

    // Call the service to update the subscription
    this.employerService
      .updateEmployerHealthSubscription(
        this.user.employerId,
        this.activeSubscriptionId,
        this.activationType,
      )
      .subscribe(
        (result) => {
          console.log("result update", result);
          this.subscriptionType = this.selectedType;
          this.activationType = this.activationType;
          // this.isActive = result.active;  // Set the active status (false)

          console.log("subscriptionType", this.subscriptionType);
          console.log("activationType", this.activationType);
          console.log("isActive", this.isActive);

            // Call to fetch updated subscription details
            this.getUserDetails();
          this.loaderService.hide();
          document.getElementById("clsModalEmp").click();

        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
  }

  openPdfDialog(type: number) {
    let url = "https://appyhealthstorage.blob.core.windows.net/customlogin/Employers Enhanced Plan HEALTH.pdf"; // Default URL
    
    // Modify the URL based on the selected plan type
    switch (type) {
      case 2:
        url = "https://appyhealthstorage.blob.core.windows.net/customlogin/Employer Enhanced Plan HEALTH PLUS.pdf";
        break;
      case 3:
        url = "https://appyhealthstorage.blob.core.windows.net/customlogin/Employer Enhanced Plan MENTAL HEALTH.pdf";
        break;
      case 4:
        url = "https://appyhealthstorage.blob.core.windows.net/customlogin/Employer Enhanced Plan HEALTH PREMIUM.pdf";
        break;
      default:
        console.warn('Unknown plan type:', type);
    }
    
    // Open the URL in a new tab
    window.open(url, '_blank');
  }

  seePlanDetails(plan: any): void{
    console.log("plan details",plan);
    // this.router.navigate(['/agency/employee-list',employer.id]);
    this.router.navigate(['/employer/empPlanDetails'], { state: { data: plan },  });
   
  }
  getPatientSubscriptionTypes(cb: () => void) {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionTypes().subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && res.result && Array.isArray(res.result)) {
          this.subscriptionTypes = res.result; // Assign the correct array
          console.log("Subscription Types:", this.subscriptionTypes);
  
          // Show success message
          // this.utils.showMessageSnackBar(res.resultStatus.message);
  
          if (typeof cb === "function") {
            cb(); // Call callback function if provided
          }
        } else {
          console.warn("Invalid response structure or request was unsuccessful:", res);
          this.subscriptionTypes = []; // Reset to prevent errors
             // Show error message if isSuccess is false
             const errorMessage = res.resultStatus.errorMessages
             ? res.resultStatus.errorMessages.join(", ")
             : "Failed to fetch subscription details.";
           
           this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription types:", error);
        this.subscriptionTypes = []; // Reset on error
        this.loaderService.hide();
        // Show error message
      this.utils.showMessageSnackBar("An error occurred while fetching subscription types.");
      }
    );
  }
}

